import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Switch, Route, Redirect } from 'react-router-dom'
import { fetchOrders } from 'lib/core/data/customer/orders'
import { Container, Content } from './components/Styled'
import { Sidebar } from './components/Sidebar'
import { Addresses } from './scenes/Addresses'
import { Orders } from './scenes/Orders'
import { Payment } from './scenes/Payment'
import { Wishlist } from './scenes/Wishlist'
import { Home } from './scenes/Home'
import { AccountHeader } from './components/AccountHeader'
import { Subscriptions } from './scenes/Subscriptions'
import { About } from './scenes/About'

export const CustomerDashboard = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchOrders())
  }, [
    dispatch
  ])

  return (
    <>
      <AccountHeader />
      <Container>
        <Sidebar />
        <Content>
          <Switch>
            <Route
              path='/customer/account/addresses'
              component={Addresses}
            />

            <Route
              path='/customer/account/dashboard'
              component={Home}
            />

            <Route
              exact
              path='/customer/account/orders'
              component={Orders}
            />

            <Route
              path='/customer/account/payment'
              component={Payment}
            />

            <Route
              path='/customer/account/subscriptions'
              component={Subscriptions}
            />

            <Route
              exact
              path='/customer/account/wishlist'
              component={Wishlist}
            />

            <Route
              exact
              path='/customer/account/about'
              component={About}
            />

            <Redirect
              to='/customer/account/dashboard'
            />
          </Switch>
        </Content>
      </Container>
    </>
  )
}
